import LayoutProvider from './layout-provider.component'

export default LayoutProvider
